module.exports = __webpack_public_path__ + "static/media/eKYC card.7312d64e.png";